import * as React from 'react';
import { ParagraphProps } from './types';

const Paragraph = ({ label }: ParagraphProps) => (
    <p>{label}</p>
);

export default Paragraph;
